import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { queries as prosBaseQueries } from "domains/connect/containers/ProsBase/queries";
import type { ConnectSearchParams } from "domains/connect/routing";
import { groupsQuery } from "domains/pros/containers/GroupList/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: ConnectSearchParams; location: ForManagerLocationDetail; allSources?: boolean };

export const queries = ({ search, location, allSources }: QueriesInput): Array<WarmableQuery> => [
  ...prosBaseQueries({ search, marketId: location.market_id, location }),
  groupsQuery({ location, allSources }),
];
